const mapaFinanceiroGrupoList = [
    {
        id: 'E', 
        descricao: 'Expansão',
        bgColor: '#012E40',
        ordem: 10,
    },
    {
        id: 'A', 
        descricao: 'Acúmulo',
        bgColor: '#024959',
        ordem: 20,
    },
    {
        id: 'P', 
        descricao: 'Proteção',
        bgColor: '#d8a726',
        ordem: 30,
    },
    {
        id: 'S', 
        descricao: 'Essencial',
        bgColor: '#838882',
        ordem: 40,
    },
]

export default mapaFinanceiroGrupoList